import { MediaMatcher } from "@angular/cdk/layout";
import { ChangeDetectorRef, Component } from "@angular/core";
import { FeatureCollection, Polygon } from "@turf/turf";
import { filter, firstValueFrom, Subscription } from "rxjs";
import { EnumFeaturesActionsDestinations } from "src/app/features/shared/helpers/enums/EnumFeaturesActionsDestinations";
import { EnumGeofenceZones } from "src/app/features/shared/helpers/enums/EnumGeofenceZones";
import { MapHelperService } from "src/services/map-helper.service";
import { PanelAddGeofencesService } from "../../../services/Panel-Add-Geofences.service";
import { GeofencesService } from "../../../services/Geofences.service";
import { HttpClient } from "@angular/common/http";

@Component({
  selector: "zone-selector",
  templateUrl: "./zone-selector.component.html",
  styleUrls: ["./zone-selector.component.css"],
})
export class ZoneSelectorComponent {
  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;
  fullScreen: boolean = false;

  selectedZoneId: number = 0;
  selectedStateId: string = "09";
  canSelectMunicipios: boolean = false;
  startedMunicipiosSelection: boolean = false;

  selectedFeaturesStateBackUp: FeatureCollection<Polygon> = { type: "FeatureCollection", features: [] };

  zones: { id: number; name: string }[] = [
    { id: EnumGeofenceZones.Estados, name: "Estados" },
    // { id: EnumGeofenceZones.Municipios, name: "Municipios" },
    // { id: EnumGeofenceZones.Regiones, name: "Regiones" },
  ];

  states: { id: string; name: string }[] = [
    { id: "09", name: "Ciudad de México" },
    { id: "05", name: "Coahuila" },
    { id: "14", name: "Querétaro" }
  ];

  regionesDummy = {
    "type": "FeatureCollection",
    "features": [
      {
        "type": "Feature",
        "id": "29",  
        "properties": {
          "nombre": "Yucatán",
          "clave": "31"
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [-90.482, 20.476],
              [-90.482, 21.847],
              [-88.693, 21.847],
              [-88.693, 20.476],
              [-90.482, 20.476]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "id": "9",
        "properties": {
          "nombre": "Ciudad de México",
          "clave": "09"
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [-99.405, 19.029],
              [-99.405, 19.480],
              [-98.950, 19.480],
              [-98.950, 19.029],
              [-99.405, 19.029]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "id": "14",
        "properties": {
          "nombre": "Jalisco",
          "clave": "14"
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [-104.496, 20.000],
              [-104.496, 21.833],
              [-102.000, 21.833],
              [-102.000, 20.000],
              [-104.496, 20.000]
            ]
          ]
        }
      }
    ]
  };


  subscription_GetFeaturesSelected: Subscription;
  constructor(changeDetectorRef: ChangeDetectorRef, 
    media: MediaMatcher,
    private mapHelperService: MapHelperService, 
    private panelAddService: PanelAddGeofencesService,
    private geofenceService : GeofencesService,
    private http: HttpClient) {
    this.mobileQuery = media.matchMedia("(min-width: 760px)");
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }

  ngOnInit(): void {
    this.panelAddService.selectedFeatures.features = [];
    this.subscription_GetFeaturesSelected = this.mapHelperService.featuresSelected$.pipe(
      filter(data => data && data.destination == EnumFeaturesActionsDestinations.Geofences)
    ).subscribe(data => {
      this.panelAddService.selectedFeatures.features = data.featureCollection.features;
      console.log("selected features updated from map", this.panelAddService.selectedFeatures);

      if(this.panelAddService.selectedFeatures.features.length == 1 || this.selectedFeaturesStateBackUp.features.length == 1){
        this.canSelectMunicipios = true;
      }else{
        this.canSelectMunicipios = false;
      }
    });

    // this.geofenceService.getStates().subscribe(data => {
    //   this.estadosDummy = data;
    // });

    this.selectedZoneId = 1;
    this.startSelector();
  }

  ngOnDestroy(): void {
    if(this.subscription_GetFeaturesSelected)
      this.subscription_GetFeaturesSelected.unsubscribe();

    this.startedMunicipiosSelection = false;
    this.stopSelector();
  }

  async startSelector(){
    this.mapHelperService.UpdateLayerGeoJson("poligonos-selector-source", this.mapHelperService.Empty_GeoJson);
    switch (this.selectedZoneId) {
      case EnumGeofenceZones.Estados:
        const path = 'assets/mexico_geoJsons/estados/mexico.geojson';
        try {
          const geo = await this.getGeoJsonFromAssets(path);
          this.mapHelperService.UpdateLayerGeoJson("poligonos-selector-source", geo);
          this.mapHelperService.FitBounds(geo);
        } catch (e) {
          console.error('Error cargando geoJson de  assets', e);
        }
        break;
      // case EnumGeofenceZones.Municipios:
      //   this.onStateSelectionChange();
      //   break;
      case EnumGeofenceZones.Regiones:
        this.mapHelperService.UpdateLayerGeoJson("poligonos-selector-source", this.regionesDummy);
        this.mapHelperService.FitBounds(this.regionesDummy);
        break;
      default:
        break;
    }
    this.mapHelperService.addMapZoneSelector(EnumFeaturesActionsDestinations.Geofences);
  }

  stopSelector(){
    this.mapHelperService.removeMapZoneSelector(EnumFeaturesActionsDestinations.Geofences);
    this.mapHelperService.UpdateLayerGeoJson("poligonos-selector-source", this.mapHelperService.Empty_GeoJson);
  }

  onZoneSelectionChange(event) {
    this.selectedZoneId = event.value;
    this.stopSelector();
    this.startSelector();
  }

  //de dummys
  // toggleMunicipiosSelection(){
  //   if (!this.startedMunicipiosSelection) {
  //     this.startedMunicipiosSelection = true;

  //     this.selectedFeaturesStateBackUp.features = this.panelAddService.selectedFeatures.features;
  //     console.log("backing up state selection", this.selectedFeaturesStateBackUp);

  //     this.selectedStateId = this.panelAddService.selectedFeatures.features.length > 0 ? this.panelAddService.selectedFeatures.features[0].properties['CVE_ENT'] : "09";

  //     // this.geofenceService.getMunicipalities(this.selectedStateId).subscribe(data => {
  //     //   this.municipiosDummy = data;
  //     // });
  //     this.mapHelperService.deselectAllZones(EnumFeaturesActionsDestinations.Geofences);
  
  //     //1 es la cdmx
  //     if(this.selectedStateId == "09"){ 
  //       this.mapHelperService.UpdateLayerGeoJson("poligonos-selector-source", this.cdmxDummy);
  //       this.mapHelperService.FitBounds(this.cdmxDummy);
  //     }
      
  //     //2 es coahuila
  //     if(this.selectedStateId == "05"){
  //       this.mapHelperService.UpdateLayerGeoJson("poligonos-selector-source", this.coahuilaDummy);
  //       this.mapHelperService.FitBounds(this.coahuilaDummy);
  //     } 
      
  //     //3 es Querétaro
  //     if(this.selectedStateId == "22"){
  //       this.mapHelperService.UpdateLayerGeoJson("poligonos-selector-source", this.queretaroDummy);
  //       this.mapHelperService.FitBounds(this.queretaroDummy);
  //     }

  //     setTimeout(() => {
  //       this.mapHelperService.selectAllZones(EnumFeaturesActionsDestinations.Geofences);
  //     }, 500);
  //   }else{
  //     this.startedMunicipiosSelection = false;
  //     this.mapHelperService.deselectAllZones(EnumFeaturesActionsDestinations.Geofences);
  //     this.mapHelperService.UpdateLayerGeoJson("poligonos-selector-source", this.mapHelperService.Empty_GeoJson);
  //     this.mapHelperService.UpdateLayerGeoJson("poligonos-selector-source", this.estadosDummy);
  //     this.mapHelperService.FitBounds(this.estadosDummy);

  //     console.log("restoring state selection", this.selectedFeaturesStateBackUp);

  //     setTimeout(() => {
  //       this.mapHelperService.selectZoneByProperty("CVE_ENT", this.selectedFeaturesStateBackUp.features[0].properties['CVE_ENT'], EnumFeaturesActionsDestinations.Geofences);
  //       this.selectedFeaturesStateBackUp.features = [];
  //     }, 500);
      
  //   }
    
  // }
  
  async toggleMunicipiosSelection(){
    if (!this.startedMunicipiosSelection) {
      this.startedMunicipiosSelection = true;

      this.selectedFeaturesStateBackUp.features = this.panelAddService.selectedFeatures.features;

      this.selectedStateId = this.panelAddService.selectedFeatures.features.length > 0 ? this.panelAddService.selectedFeatures.features[0].properties['CVE_ENT'] : "09";

      this.mapHelperService.deselectAllZones(EnumFeaturesActionsDestinations.Geofences);

      const stateName = this.selectedFeaturesStateBackUp.features.length > 0 ? this.selectedFeaturesStateBackUp.features[0].properties['NOM_ENT'] : "México";
      console.log("seleccionado estado", this.selectedFeaturesStateBackUp.features, stateName);
      
      const path = 'assets/mexico_geoJsons/municipios/'+ stateName +'.json';
      try {
        const geo = await this.getGeoJsonFromAssets(path);
        this.mapHelperService.UpdateLayerGeoJson("poligonos-selector-source", geo);
        this.mapHelperService.FitBounds(geo);
      } catch (e) {
        console.error('Error cargando geoJson de  assets', e);
      }

      // setTimeout(() => {
      //   this.mapHelperService.selectAllZones(EnumFeaturesActionsDestinations.Geofences);
      // }, 500);
    }else{
      this.startedMunicipiosSelection = false;
      this.mapHelperService.deselectAllZones(EnumFeaturesActionsDestinations.Geofences);
      this.mapHelperService.UpdateLayerGeoJson("poligonos-selector-source", this.mapHelperService.Empty_GeoJson);
      const path = 'assets/mexico_geoJsons/estados/mexico.geojson';
      try {
        const geo = await this.getGeoJsonFromAssets(path);
        this.mapHelperService.UpdateLayerGeoJson("poligonos-selector-source", geo);
        this.mapHelperService.FitBounds(geo);
      } catch (e) {
        console.error('Error cargando geoJson de  assets', e);
      }
      console.log("restoring state selection", this.selectedFeaturesStateBackUp);

      setTimeout(() => {
        this.mapHelperService.selectZoneByProperty("CVE_ENT", this.selectedFeaturesStateBackUp.features[0].properties['CVE_ENT'], EnumFeaturesActionsDestinations.Geofences);
        this.selectedFeaturesStateBackUp.features = [];
      }, 500);
      
    }
    
  }

  async getGeoJsonFromAssets(path: string): Promise<GeoJSON.FeatureCollection> {
    const geo = await firstValueFrom(this.http.get(path)) as GeoJSON.FeatureCollection;
    geo.features.forEach((feature, index) => {
      if (feature.id == undefined || feature.id == null) 
        feature.id = index + 1;
    });
    return geo;
  }
}
